import React from 'react';
import {
  bool, shape, func, string, number
} from 'prop-types';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { LayoutGroup, LayoutManager } from '@thd-olt-component-react/layout-manager';
import { TrackOutOfStock } from '@thd-olt-component-react/track-out-of-stock';
import { BuyboxActions } from './BuyboxActions';
import * as helper from '../../BuyboxHelper';
import '../buybox.scss';

const BuyboxLite = ({
  itemId,
  unavailable,
  storeId,
  isOutOfStockOnline,
  isShowATC,
  covidAlert,
  storeZip,
  isATCDisabled,
  channel,
  zipCode,
  fulfillmentMethod,
  fulfillment,
  availabilityType,
  paypalEligible,
  onFulfillmentChange,
  onDeliveryOptionsZipCodeChange,
  onATCClick,
  bopisHolidayTiming
}) => {
  if (channel === 'mobile') {
    const shippingTemplate = helper.renderShippingFulfillment({ fulfillment, availabilityType });
    return (
      <Row>
        <Col fallback="12" className="buybox-wrapper">
          {shippingTemplate.showATC && (
            <div className="buybox__atc--wrapper">
              <AddToCart
                cartOptions={helper.getCartOptions({
                  channel,
                  fulfillmentMethod: shippingTemplate.method,
                  alterBrowserHistory: true
                })}
                cartReqParams={helper.getCartReqParams({
                  itemId,
                  storeZip,
                  fulfillmentMethod: shippingTemplate.method,
                  quantity: 1,
                  zipCode,
                  storeId,
                  fulfillment
                })}
                onClick={onATCClick}
                disabled={isATCDisabled}
              >
                Add to Cart
              </AddToCart>
            </div>
          )}
          <div className={`${shippingTemplate.oos ? '' : 'fulfillment--lite'}`}>
            {shippingTemplate.template}
          </div>
          {shippingTemplate.oos && (
            <LayoutManager name="track-out-of-stock">
              <LayoutGroup name="alerts">
                <TrackOutOfStock itemId={itemId} />
              </LayoutGroup>
            </LayoutManager>
          )}
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      <Col fallback="12" className="buybox-wrapper">
        <div className="buybox-wrapper__lite">
          <div className="buybox-top__wrapper">
            {!unavailable && (
              <div className="buybox__fulfillment-wrapper">
                <div className="buybox__fulfillment">
                  <Fulfillment
                    itemId={itemId}
                    covidAlert={covidAlert}
                    onChange={onFulfillmentChange}
                    onDeliveryZipCodeChange={onDeliveryOptionsZipCodeChange}
                    bopisHolidayTiming={bopisHolidayTiming}
                  />
                </div>
              </div>
            )}
          </div>
          {!isOutOfStockOnline && isShowATC && (
            <div className="buybox__actions">
              <BuyboxActions
                alterBrowserHistory
                itemId={itemId}
                storeId={storeId}
                storeZip={storeZip}
                disableATC={isATCDisabled}
                channel={channel}
                zipCode={zipCode}
                fulfillmentMethod={fulfillmentMethod}
                fulfillment={fulfillment}
                paypalEligible={paypalEligible}
                onATCClick={onATCClick}
                hideQuantity
              />
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

BuyboxLite.propTypes = {
  itemId: string,
  unavailable: bool,
  covidAlert: bool,
  bopisHolidayTiming: number,
  storeId: string,
  isOutOfStockOnline: bool,
  isShowATC: bool,
  storeZip: string,
  isATCDisabled: bool,
  channel: string,
  zipCode: string,
  fulfillmentMethod: string,
  fulfillment: shape({
    backordered: bool
  }),
  availabilityType: shape({
    discontinued: bool,
    status: bool,
    buyable: bool,
    type: string
  }),
  paypalEligible: bool,
  onFulfillmentChange: func,
  onDeliveryOptionsZipCodeChange: func,
  onATCClick: func
};

BuyboxLite.defaultProps = {
  itemId: null,
  unavailable: false,
  storeId: null,
  isOutOfStockOnline: false,
  isShowATC: true,
  covidAlert: false,
  storeZip: null,
  isATCDisabled: false,
  channel: 'desktop',
  zipCode: null,
  fulfillmentMethod: null,
  fulfillment: null,
  availabilityType: null,
  paypalEligible: false,
  onFulfillmentChange: () => {},
  onDeliveryOptionsZipCodeChange: () => {},
  onATCClick: () => {},
  bopisHolidayTiming: null
};

export { BuyboxLite };
